import(/* webpackMode: "eager" */ "/vercel/path0/app/memory/page.jsx");
